import { Box } from '@mui/material';
import { DropDown, ChipInput, ChipInputTagErrors } from '@qrios/frontend-library';

import DateRangePicker from '../../../../../../common/fields/date-range-picker';
import { FiltersFormValues } from '../../../../../../common/reports/interfaces';
import { BILLING_STATUSES, FILTERS, OPERATORS } from '../../../../../../common/filters/constants';

import locales from '../locales';
import { SmsReportCreateForm } from '../interfaces';

interface Props extends FiltersFormValues<SmsReportCreateForm> {}

const FiltersForm = ({ errors, touched, values, handleChange, handleBlur }: Props) => (
  <Box mt={2} mb={6}>
    <DateRangePicker
      from={{ name: FILTERS.FROM, value: values.from, error: errors.from, touched: touched.from }}
      to={{ name: FILTERS.TO, value: values.to, error: errors.to, touched: touched.to }}
      handleFromChange={value => handleChange(FILTERS.FROM, value)}
      handleToChange={value => handleChange(FILTERS.TO, value)}
      handleBlur={handleBlur}
    />
    <DropDown
      label={locales.filtersForm.operators.label}
      value={values.operators}
      options={OPERATORS}
      name="operators"
      handleChange={handleChange}
      handleBlur={handleBlur}
      multiple={true}
      placeholder={locales.filtersForm.operators.placeholder}
    />
    <DropDown
      label={locales.filtersForm.statuses.label}
      placeholder={locales.filtersForm.statuses.placeholder}
      value={values.statuses}
      options={BILLING_STATUSES}
      name="statuses"
      handleChange={handleChange}
      handleBlur={handleBlur}
      multiple={true}
    />
    <ChipInput
      error={errors.operationIds?.[(errors.operationIds ?? []).length - 1]}
      label={locales.filtersForm.operationIds.label}
      value={values.operationIds}
      name="operationIds"
      handleChange={handleChange}
      handleBlur={handleBlur}
      placeholder={locales.filtersForm.operationIds.placeholder}
      tagErrors={errors.operationIds as ChipInputTagErrors}
    />
    <ChipInput
      error={errors.recipientMsisdns?.[(errors.recipientMsisdns ?? []).length - 1]}
      label={locales.filtersForm.recipientMsisdns.label}
      value={values.recipientMsisdns}
      name="recipientMsisdns"
      handleChange={handleChange}
      handleBlur={handleBlur}
      placeholder={locales.filtersForm.recipientMsisdns.placeholder}
      tagErrors={errors.recipientMsisdns as ChipInputTagErrors}
    />
  </Box>
);

export default FiltersForm;
